// extracted by css-extract-rspack-plugin
export default {"tooltip":"CopyToClipboardButton-module__tooltip__eCErBjn"};